import { render, staticRenderFns } from "./RangeLabel.vue?vue&type=template&id=12fefca4&lang=html&"
import script from "./RangeLabel.vue?vue&type=script&lang=js&"
export * from "./RangeLabel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "RangeLabel.vue"
export default component.exports